import {
  LOCAL_NEW_IMAGES,
  LOCAL_UPDATED_IMAGES,
} from "../constants/local-entity";
import {LOCAL_NEW_STATE, LOCAL_UPDATE_STATE} from "../constants/states";
import {getLocal, putLocal} from "../helpers/local-storage";
import {saveImages, updateImagesDB} from "../mongo-db/images";

export const storeImages = async dataImages => {
  console.log('[storeImages] Iniciando...');
  const imagesCount = Object.keys(dataImages.images).reduce((acc, key) => {
    return acc + (dataImages.images[key]?.length || 0);
  }, 0);
  console.log(`[storeImages] IdForm: ${dataImages.IdForm}, Total de imágenes: ${imagesCount}`);

  if (navigator.onLine) {
    console.log('[storeImages] Online - Llamando saveImages()');
    const result = await saveImages(dataImages);
    console.log('[storeImages] Respuesta de saveImages:', result);

    if (result?.success) {
      console.log(`[storeImages] ✓ Éxito en servidor - ID: ${result.id}, limpiando localStorage`);
      const localImages = getLocal(LOCAL_NEW_IMAGES, []);
      const cleaned = localImages.filter(i => i.IdForm !== dataImages.IdForm);
      putLocal(LOCAL_NEW_IMAGES, cleaned);
      console.log('[storeImages] ✓ localStorage limpiado para sincronizar posteriormente');
      return true;
    } else {
      console.error('[storeImages] ✗ FALLO en servidor, encolando en localStorage para retry');
      const localImages = getLocal(LOCAL_NEW_IMAGES, []);
      if (!localImages.some(i => i.IdForm === dataImages.IdForm)) {
        localImages.push({...dataImages, state: LOCAL_NEW_STATE});
        putLocal(LOCAL_NEW_IMAGES, localImages);
      }
      return result?.error || "server";
    }
  } else {
    console.log('[storeImages] Offline - Guardando en LOCAL_NEW_IMAGES (NO limpiar, se sincronizará después)');
    const localImages = getLocal(LOCAL_NEW_IMAGES, []);
    const localDataImages = {...dataImages, state: LOCAL_NEW_STATE};
    localImages.push(localDataImages);

    const result = putLocal(LOCAL_NEW_IMAGES, localImages);
    console.log(`[storeImages] ${result ? '✓' : '✗'} putLocal retornó:`, result);
    return result || "quota";
  }
};

export const updateImages = async (formId, dataImages) => {
  console.log('[updateImages] Iniciando...');
  const imagesCount = Object.keys(dataImages.images).reduce((acc, key) => {
    return acc + (dataImages.images[key]?.length || 0);
  }, 0);
  console.log(`[updateImages] IdForm: ${formId}, Total de imágenes: ${imagesCount}`);

  if (navigator.onLine) {
    console.log('[updateImages] Online - Llamando updateImagesDB()');

    const result = await updateImagesDB(formId, dataImages);
    console.log('[updateImages] Respuesta de updateImagesDB:', result);

    if (result?.success) {
      console.log('[updateImages] ✓ Éxito en servidor - Actualizado en BD, limpiando localStorage');
      let localNewImages = getLocal(LOCAL_NEW_IMAGES, []);
      let localImagesToUpdate = getLocal(LOCAL_UPDATED_IMAGES, []);

      localNewImages = localNewImages.filter(i => i.IdForm !== formId);
      localImagesToUpdate = localImagesToUpdate.filter(i => i.IdForm !== formId);

      putLocal(LOCAL_NEW_IMAGES, localNewImages);
      putLocal(LOCAL_UPDATED_IMAGES, localImagesToUpdate);
      console.log('[updateImages] ✓ localStorage limpiado para sincronizar posteriormente');
      return true;
    } else {
      console.error('[updateImages] ✗ FALLO en servidor, encolando en localStorage para retry');
      let localImagesToUpdate = getLocal(LOCAL_UPDATED_IMAGES, []);
      if (!localImagesToUpdate.some(i => i.IdForm === formId)) {
        localImagesToUpdate.push({...dataImages, state: LOCAL_UPDATE_STATE});
        putLocal(LOCAL_UPDATED_IMAGES, localImagesToUpdate);
      }
      return result?.error || "server";
    }
  } else {
    console.log('[updateImages] Offline - Guardando en LOCAL_UPDATED_IMAGES (NO limpiar, se sincronizará después)');
    let localNewImages = getLocal(LOCAL_NEW_IMAGES, []);
    let localImagesToUpdate = getLocal(LOCAL_UPDATED_IMAGES, []);

    const newImages = localNewImages.find(i => i.IdForm === formId);
    const imagesToUpdate = localImagesToUpdate.find(i => i.IdForm === formId);
    const localImages = {...dataImages, state: LOCAL_UPDATE_STATE};

    if (newImages) {
      console.log('[updateImages] Encontrado en LOCAL_NEW_IMAGES, moviendo a LOCAL_UPDATED_IMAGES');
      localNewImages = localNewImages.filter(i => i.IdForm !== formId);
      localImagesToUpdate.push(localImages);
    } else if (imagesToUpdate) {
      console.log('[updateImages] Encontrado en LOCAL_UPDATED_IMAGES, actualizando');
      localImagesToUpdate = localImagesToUpdate.map(i => {
        return i.IdForm === formId ? localImages : i;
      });
    } else {
      console.log('[updateImages] No encontrado localmente, creando nuevo en LOCAL_UPDATED_IMAGES');
      localImagesToUpdate.push(localImages);
    }

    const result1 = putLocal(LOCAL_NEW_IMAGES, localNewImages);
    const result2 = putLocal(LOCAL_UPDATED_IMAGES, localImagesToUpdate);

    const finalResult = result1 && result2;
    console.log(`[updateImages] ${finalResult ? '✓' : '✗'} putLocal retornó:`, {result1, result2});
    return finalResult || "quota";
  }
};
 